export default "/images/vendor/flag-icon-css/flags/4x3/un.svg?4388dfb01646ff8dc71da3b120d30ab5";